export class StepIndicatorModel {
  label: string;
  stepNumber: number;
  path: string;
  isVisited: boolean;
}
